import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxMaskDirective } from 'ngx-mask';
import { HouseholdRecordVm } from '@k12/models';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';

export const CUSTOM_DATE_FORMATS = {
  parse: { dateInput: 'MM/DD/YYYY' },
  display: { dateInput: 'MM/DD/YYYY' }
};

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-household-parent-info',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMaskDirective,
    MatMomentDateModule
  ],
  templateUrl: './household-parent-info.component.html',
  providers: [{ provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }]
})
export class HouseholdParentInfoComponent {
  @Input() formGroup!: FormGroup;
  @Input() householdData: HouseholdRecordVm;

  formatSsn(ssn: string): string {
    if (!ssn) return 'N/A';
    if (ssn.length === 9) {
      return `${ssn.substring(0, 3)}-${ssn.substring(3, 5)}-${ssn.substring(5, 9)}`;
    }
    return ssn;
  }
}
